$(document).ready(function () {
  const checkbox1 = $("#terms-and-condition-1").is(":checked");
  const checkbox2 = $("#terms-and-condition-2").is(":checked");
  if (!checkbox1) {
    $("#register-button-1").attr("disabled", true);
  }

  if (!checkbox2) {
    $("#register-button-2").attr("disabled", true);
  }
  $("#terms-and-condition-1").change(function (e) {
    if (!e.target.checked) {
      $("#register-button-1").attr("disabled", true);
    } else {
      $("#register-button-1").removeAttr("disabled");
    }
  });

  $("#terms-and-condition-2").change(function (e) {
    if (!e.target.checked) {
      $("#register-button-2").attr("disabled", true);
    } else {
      $("#register-button-2").removeAttr("disabled");
    }
  });

  $(".terms-condition-popup-close").on("click", function () {
    $(".lity-close").removeClass("hidden");
    const val = $(".terms-and-condition-container").hasClass("hidden");
    if (!val) {
      $(".terms-and-condition-container").addClass("hidden");
    }
  });

  $(".terms-and-condition-popup").on("click", function () {
    $(".lity-close").addClass("hidden");
    const val = $(".terms-and-condition-container").hasClass("hidden");
    if (val) {
      $(".terms-and-condition-container").removeClass("hidden");
    }
  });
});

$("#complaint-register").on("click", (event) => {
  event.preventDefault();
  $(".complaint-otp-login-popup").removeClass("hidden");
  $("body").attr("overflow", "hidden");
  $("body").addClass("overflow-hidden");
});

$(".complaint-otp-login-popup .cf-icon-close svg").on("click", () => {
  $(".complaint-otp-login-popup").addClass("hidden");
  $("body").removeAttr("overflow");
  $("body").removeClass("overflow-hidden");
  setTimeout(() => {
    $("#cfMobileNumber").focus(); // Set focus on the input field after a delay of 200 milliseconds
  }, 200);
});

// Input field event listener to allow only numeric input
$("#cfMobileNumber").on("input", function () {
  let numericValue = this.value.replace(/\D/g, ""); // Remove non-numeric characters from the input value
  if (this.value !== numericValue) {
    this.value = numericValue; // Update the input value with the numeric value
  }
});

let countDown;
let second = 30;

function startOtpTimer() {
  countDown = setInterval(function () {
    second--;
    if (second >= 0) {
      $("#otptimer").text(second);
    } else {
      clearInterval(countDown);
      $("#complaint-edit-number-button").show();
      $("#complaint-resend-otp-button").show();
      $(".complaint-resend-text").hide();
      $("#otptimer").hide();
      $("#spinner-svg").show();
    }
  }, 1000);
}

function resetOtpTimer() {
  clearInterval(countDown);
  second = 30;
  $("#otptimer").text(second);
}

$("#complaint-resend-otp-button").hide();
$("#complaint-resend-spinner").hide();

function complaintSendOTP() {
  $(".cf-otp-input").val("");
  let phoneNumber = $("#cfMobileNumber").val();
  let payload = {
    phoneNumber: phoneNumber,
  };

  $.ajax({
    url: "https://orient.marmeto.com/api/anonymous/otp",
    type: "POST",
    data: JSON.stringify(payload),
    contentType: "application/json",
    success: function (response) {
      if (response.status == "FAILURE") {
        $(".no-account-error-text").removeClass("hidden");
        $("#spinner-svg").hide();
        $('#complaint-mobile-number button[type="submit"]').removeAttr(
          "disable"
        );
      } else {
        $(".no-account-error-text").addClass("hidden");
        $("#complaint-mobile-number").hide();
        $("#complaint-otp-verification").show();
        $('#complaint-mobile-number button[type="submit"]').removeAttr(
          "disable"
        );
        $("#spinner-svg").hide();
        $("#complaint-mobile-number").hide();
        $("#complaint-edit-number-button").hide();
        startOtpTimer();
      }
    },
    error: function (xhr, status, error) {
      alert("POST request failed. Status code:", xhr.status);

      if (xhr.status === 400) {
        alert("Bad request response:", xhr.responseText);
      }
    },
  });
}
$("#complaint-otp-verification").hide();

// Event listener for form submission
// $("#complaint-mobile-number").on("submit", function (e) {
//   e.preventDefault();

//   const mobileNumber = $("#cfMobileNumber").val();
//   if (mobileNumber.length < 10) {
//     $(".invalid-number").text("Please enter a valid mobile number.");
//     $(".invalid-number").show();
//     return;
//   }

//   $('#complaint-mobile-number button[type="submit"]').attr("disabled", true);
//   $("#complaint-entered-number").text(mobileNumber);
//   $("#phone_1, #phone").val(mobileNumber).prop("disabled", true);
//   $("#spinner-svg").show();

//   // checkOpenQuery(mobileNumber);
//   complaintSendOTP();
// });

$("#complaint-mobile-number").on("submit", function (e) {
  e.preventDefault();

  const mobileNumber = $("#cfMobileNumber").val();
  if (mobileNumber.length < 10) {
    $(".invalid-number").text("Please enter a valid mobile number.");
    $(".invalid-number").show();
    return;
  }

  $('#complaint-mobile-number button[type="submit"]').attr("disabled", true);
  $("#complaint-entered-number").text(mobileNumber);
  $("#phone_1, #phone").val(mobileNumber).prop("disabled", true);
  $("#spinner-svg").show();

  complaintSendOTP();
});

// Event listener to enable the submit button when the user starts typing
$("#cfMobileNumber").on("input", function () {
  $('#complaint-mobile-number button[type="submit"]').removeAttr("disabled");
});

// Function to handle the fetch call-- to check Complaint Open query
async function checkOpenQuery(mobileNumber) {
  const formData = {
    customerMobileNumber: mobileNumber,
  };

  try {
    const response = await fetch(
      "https://orientform.marmeto.com/api/complaint-tracking",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${sessionStorage.getItem("complaintVerificationToken")}`
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await response.json(); // Parse response as JSON
    let hasOpenQuery = false;

    // Check each call record for "Open" status
    data.callList.forEach((call) => {
      if (call.callStatusDescription.includes("Open")) {
        hasOpenQuery = true;
      }
    });

    if (hasOpenQuery) {
      $(".invalid-number").text("You have an open query, please try later.");
      $(".invalid-number").show();
      $('.complaint-submit-button button[type="submit"]').attr(
        "disabled",
        false
      );
      $("#spinner-svg").hide();
    } else {
      $(".invalid-number").hide();
      $('.complaint-submit-button button[type="submit"]').attr(
        "disabled",
        false
      );
      $("#spinner-svg").hide();
      complaintSendOTP();
    }
  } catch (error) {
    console.error("Fetch error:", error);
    alert("There was an error checking the status. Please try again later.");
    $('.complaint-submit-button button[type="submit"]').attr("disabled", false);
    $("#spinner-svg").hide();
  }
}

$("#complaint-resend-otp-button").click(function (e) {
  e.preventDefault();
  resetOtpTimer();
  $(".cf-otp-input").val("");
  $("#complaint-resend-otp-button").hide();
  $("#complaint-edit-number-button").hide();
  $("#complaint-invalid-OTP ").hide();

  let phoneNumber = $("#cfMobileNumber").val();
  let payload = {
    phoneNumber: phoneNumber,
  };

  $("#complaint-resend-spinner").show();

  $.ajax({
    url: "https://orient.marmeto.com/api/anonymous/otp",
    type: "POST",
    data: JSON.stringify(payload),
    contentType: "application/json",
    success: function (response) {
      $("#complaint-otp-verification").show();
      $(this).removeAttr("disabled", "disabled");
      $("#spinner-svg").hide();
      setTimeout(function () {
        $("#complaint-resend-spinner").hide();
        $(".complaint-resend-text").show();
        $("#otptimer").show();
        startOtpTimer();
      }, 1000);
    },
    error: function (xhr, status, error) {
      alert("An error occurred while processing the request");

      if (xhr.status === 400) {
        alert("Bad request response:", xhr.responseText);
      }
    },
  });
});

$("#complaint-edit-number-button").click(function (e) {
  e.preventDefault();
  $(".complaint-invalid-OTP").hide();
  $("#complaint-otp-verification").hide();
  $('#complaint-mobile-number button[type="submit"]').removeAttr("disable");
  $("#spinner-svg").hide();
  $("#complaint-resend-otp-button").hide();
  $(".complaint-resend-text").show();
  $("#otptimer").show();
  $("#complaint-mobile-number").show();
  $(".cf-otp-input").val("");
  $("#cfMobileNumber").focus();

  resetOtpTimer();
});

// Limit input to a single character for number inputs
$(
  "#complaintOTPinput1, #complaintOTPinput2, #complaintOTPinput3, #complaintOTPinput4"
).on("input", function () {
  if ($(this).val().length > 1) {
    $(this).val($(this).val().charAt(0));
  }
});

//OTP verify
$("#complaint-otp-verification").on("submit", function (e) {
  // Get the mobile number and OTP input values
  e.preventDefault();

  let cfMobileNumber = $("#cfMobileNumber").val();
  let otpInput1 = $("#complaintOTPinput1").val();
  let otpInput2 = $("#complaintOTPinput2").val();
  let otpInput3 = $("#complaintOTPinput3").val();
  let otpInput4 = $("#complaintOTPinput4").val();
  let otp = otpInput1 + otpInput2 + otpInput3 + otpInput4;

  if (otp.length != 4) {
    $(".complaint-invalid-OTP").show();
    $("#complaint-OTP-submit-button").attr("disable", "disable");
    return;
  }
  $("#complaint-OTP-submit-button").attr("disable", "disable");
  let payload = {
    phoneNumber: cfMobileNumber,
    otp: otp,
  };
  // Make the POST request to verify the OTP
  $.ajax({
    url: "https://orient.marmeto.com/api/anonymous/verify",
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (data) {
      sessionStorage.removeItem("complaintVerificationToken");
      // Handle the response data as needed
      let response = data;
      if (response.status == "OTP_INVALID") {
        $(".complaint-invalid-OTP").show();
      } else {
        // ✅ STORE verificationToken in sessionStorage
        if (response.verificationToken) {
          sessionStorage.setItem("complaintVerificationToken", response.verificationToken);
        }
        $(".complaint-invalid-OTP").hide();
        // $(".complaint-otp-login-popup .cf-icon-close svg").click();
        // $("#complaint-otp-verification").hide();
        // $(".popup-overlay").removeClass("hidden");
        // openOverlay();
        const mobileNumber = $("#cfMobileNumber").val();

        // 👉 OTP success ke baad check karo
        checkOpenQueryAfterOTP(mobileNumber);
        $("#complaint-OTP-submit-button").removeAttr("disable", "disable");
      }
    },
    error: function (xhr, status, error) {
      // Handle any errors that occurred during the request
      const responseText = xhr.responseText;
      const responseJson = JSON.parse(responseText);
      const message = responseJson.message;
      $(".complaint-invalid-OTP").show();

      if (xhr.status === 400) {
        console.log("Bad request response:", xhr.responseText);
      }
      $("#complaint-OTP-submit-button").removeAttr("disable", "disable");
    },
  });
});

$(".cf-otp-input").on("paste", function (e) {
  let pastedData = e.originalEvent.clipboardData.getData("text");
  let otpInputs = $(this).closest("form").find(".cf-otp-input");
  let currentIndex = otpInputs.index(this);
  let otpArray = pastedData.trim().split("");

  // Fill the OTP input fields with the pasted values
  otpArray.forEach(function (value, index) {
    if (currentIndex + index < otpInputs.length) {
      $(otpInputs[currentIndex + index]).val(value);
    }
  });

  $(otpInputs[currentIndex + otpArray.length]).focus();
  // Trigger the keyup event for the last input to handle validation or further actions
  $(otpInputs[currentIndex + otpArray.length - 1]).trigger("keyup");
});

window.backSpace = 0;

function SignhandleOtpInput(inputNumber, event) {
  const input = document.getElementById(`complaintOTPinput${inputNumber}`);
  const inputValue = event.target.value;
  const filteredValue = inputValue.replace(/[^0-9.]/g, "");
  input.value = filteredValue;

  if (filteredValue.length === 1) {
    if (inputNumber < 4) {
      const nextInput = document.getElementById(
        `complaintOTPinput${inputNumber + 1}`
      );
      nextInput.focus();
    }
  } else {
    // Focus on the previous input field if available
    if (inputNumber > 1) {
      if (window.backSpace == 1) {
        const previousInput = document.getElementById(
          `complaintOTPinput${inputNumber - 1}`
        );
        previousInput.focus();
        window.backSpace = 0;
      } else {
        window.backSpace = 1;
        input.focus();
      }
    } else {
      window.backSpace = 0;
    }
  }
}

$(".cf-otp-input").each(function () {
  $(this).on("input", function () {
    $("#complaint-OTP-submit-button").removeAttr("disable", "disable");
    $(".complaint-invalid-OTP").hide();
  });
});

$("#complaint-otp-verification").hide();
$(".complaint-otp-login-popup").addClass("hidden");

const overlay = document.getElementById("overlay");
const body = document.body;
// Function to open the overlay
function openOverlay() {
  overlay.classList.remove("hidden");
  body.classList.add("overflow-hidden");
}

// Function to close the overlay
function closeOverlay() {
  overlay.classList.add("hidden");
  body.classList.remove("overflow-hidden");
  $(".complaint-otp-login-popup").addClass("hidden");
  $("#complaint-mobile-number").show();
}

// Function to handle checkbox changes
function handleRadioChange(radio) {
  const radios = document.querySelectorAll(
    'input[type="radio"][name="complaint"]'
  );
  const dataForm = radio.getAttribute("data-form");
  const complaintForm1 = document.querySelector(".complaint_form_1");
  const complaintForm2 = document.querySelector(".complaint_form_2");
  const registerButton = document.getElementById("registerButton");

  radios.forEach(function (radio) {
    radio.checked = false;
  });
  radio.checked = true;

  // Get the value of the checked radio
  const selectedValue = radio.value;

  if (selectedValue) {
    registerButton.setAttribute("data-lity", "true");
    if (dataForm === "form_2") {
      complaintForm2.classList.remove("hidden");
      complaintForm1.classList.add("hidden");
      const queryTypeSelected = document.querySelector("#issue");
      queryTypeSelected.innerHTML = selectedValue;
    } else if (dataForm === "form") {
      complaintForm1.classList.remove("hidden");
      complaintForm2.classList.add("hidden");

      const queryTypeSelectedLabel = document.querySelector(
        ".query-type-selected"
      );
      queryTypeSelectedLabel.innerHTML = selectedValue;

      let techRemarkOptions = document.querySelector(
        ".complaint-query-options select"
      );
      techRemarkOptions.innerHTML = "";
      if (selectedValue === "Sales Query") {
        // Create an array of options
        const queryOptions = [
          "Select a Query",
          "Price",
          "Product",
          "Warranty Policy",
        ];
        // Loop through the array and create option elements
        queryOptions.forEach((optionText, index) => {
          const option = document.createElement("option");
          option.value = optionText;
          option.text = optionText;
          // Disable the first option
          if (index === 0) {
            option.disabled = true;
            option.selected = true;
            option.value = "";
          }
          techRemarkOptions.appendChild(option);
        });
      } else if (selectedValue === "Order & Payment Related") {
        const queryOptions = [
          "Select a Query",
          "Order Modification",
          "Order Cancellation",
        ];
        // Loop through the array and create option elements
        queryOptions.forEach((optionText, index) => {
          const option = document.createElement("option");
          option.value = optionText;
          option.text = optionText;
          // Disable the first option
          if (index === 0) {
            option.disabled = true;
            option.selected = true;
            option.value = "";
          }
          techRemarkOptions.appendChild(option);
        });
      } else if (selectedValue === "Delivery Related") {
        const queryOptions = [
          "Select a Query",
          "Damaged Delivery",
          "Delay Delivery",
        ];
        // Loop through the array and create option elements
        queryOptions.forEach((optionText, index) => {
          const option = document.createElement("option");
          option.value = optionText;
          option.text = optionText;
          // Disable the first option
          if (index === 0) {
            option.disabled = true;
            option.selected = true;
            option.value = "";
          }
          techRemarkOptions.appendChild(option);
        });
      } else if (selectedValue === "Others") {
        const queryOptions = ["Select a Query", "free text"];
        // Loop through the array and create option elements
        queryOptions.forEach((optionText, index) => {
          const option = document.createElement("option");
          option.value = optionText;
          option.text = optionText;
          // Disable the first option
          if (index === 0) {
            option.disabled = true;
            option.selected = true;
            option.value = "";
          }
          techRemarkOptions.appendChild(option);
        });
      }
    }
  }
}

// Add event listeners to radios to handle their changes
const radios = document.querySelectorAll(
  'input[type="radio"][name="complaint"]'
);
radios.forEach(function (radio) {
  radio.addEventListener("change", function () {
    handleRadioChange(radio);
  });
});

const closeOverlayIcon = document.getElementById("pop-close_overlay");
closeOverlayIcon.addEventListener("click", function () {
  closeOverlay();
});

$(document).ready(function () {
  populatefield("State", "values?asset=state", "#state_1", true);
  $("#state_1").change(function () {
    populatefield(
      "City",
      "values?asset=city&filter=" + $(this).val() + "&filter_col=2",
      "#city_1",
      $(this).val()
    );
  });
  $("#city_1").change(function () {
    populatefield(
      "Area",
      "values?asset=area&filter=" + $(this).val() + "&filter_col=2",
      "#area_1",
      $(this).val()
    );
  });
  $("#area_1").change(function () {
    populatefield(
      "Pincode",
      "values?asset=pincode&filter=" +
        $(this).val().split("|")[1] +
        "&filter_col=2",
      "#pincode_1",
      $(this).val()
    );
  });

  function populatefield(field, slug, field_id, parent) {
    $.ajax({
      url: "https://orientform.marmeto.com/" + slug,
      success: function (response) {
        $(field_id).html(
          '<option value="" disabled selected>Select ' + field + " *</option>"
        );
        if ($(field_id).length > 0 && parent) {
          data = response.data;
          $(data).each(function () {
            if (field == "Area") {
              $(field_id).append(
                `<option value="${this.description}|${this.lookupCode}">${this.description}</option>`
              );
            } else if (field == "Pincode") {
              $(field_id).append(
                '<option value="' +
                  this.description +
                  '">' +
                  this.description +
                  "</option>"
              );
            } else {
              $(field_id).append(
                '<option value="' +
                  this.lookupCode +
                  '">' +
                  this.description +
                  "</option>"
              );
            }
          });
        }
      },
    });
  }

  $("#ContactForm_1").submit(function (e) {
    e.preventDefault();
    let valid = true;
    if (!emptyFieldValidationCheck()) {
      valid = false;
    }
    let emailAlertValue;
    const isChecked = $("#email-alert").prop("checked");
    if (isChecked) {
      emailAlertValue = "Yes";
    } else {
      emailAlertValue = "No";
    }
    if (valid) {
      $("#ContactForm_1").find('button[type="submit"]').addClass("loading");
      const rawDate = new Date($("#date_1").val());
      const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", 
                "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

      const formattedDate = `${rawDate.getDate().toString().padStart(2, '0')}-${months[rawDate.getMonth()]}-${rawDate.getFullYear()}`;
      const verificationToken = sessionStorage.getItem("complaintVerificationToken");

      let formData = {
        customer: {
          mobile_no: $("#phone_1").val(),
          name: $("#name_name_1").val(),
          address: $("#address_1").val(),
          state: $("#state_1").val(),
          city: $("#city_1").val(),
          pincode: $("#pincode_1").val(),
          area: $("#area_1").val().split("|")[0],
          email: $("#email_email_1").val(),
          emailAlert: emailAlertValue,
          customerType: window.location.href.includes("employee-complaint-form") ? "Employee" : "Customer"
        },
        product: {
          purchaseDate: formattedDate
        },
        remarks: $(".query-type-selected").text(),
        techRemarks: $(".complaint-query-option-selected").val(),
      };
      let settings = {
        url: "https://orientform.marmeto.com/api/register-enquiry",
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + verificationToken
        },
        data: JSON.stringify(formData),
      };
      $.ajax(settings).done(function (response) {
        closeOverlay();
        if (response.statusCode == 200) {
          $("#form_response").text(
            "Thank you for registering your complaint. We appreciate your patience and will connect with you soon to promptly resolve your issue."
          );
        } else {
          // Show API response message
          $("#form_response").text(response.messageDescription);
        }
        lity("#contact_form_main_popup_response");
        $("#contact_form_main_popup .lity-close").trigger("click");
        $("#ContactForm_1")
          .find('button[type="submit"]')
          .removeClass("loading");
        $(
          "#name_name_1, #phone_1, #email_email_1, #address_1, #country_1, #state_1, #city_1, #area_1, #pincode_1, .query-type-selected, .complaint-query-option-selected"
        ).val("");
      });
    } else {
      alert("In valid details entered");
    }
  });
});

function emptyFieldValidationCheck() {
  let emptyfieldcheck = true;
  $(" #ContactForm_1")
    .find(".required")
    .each(function () {
      if ($(this).val()) {
        $(this).parent(".field_wrap").removeClass("error blank-error");
      } else {
        $(this).parent(".field_wrap").addClass("error blank-error");
        emptyfieldcheck = false;
      }
    });
  return emptyfieldcheck;
}

// Email Field Validation
function isEmail(email) {
  let regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
}

function emailValidation() {
  let email_check = true;
  $("#ContactForm_1")
    .find(".email")
    .each(function () {
      if (isEmail($(this).val())) {
        $(this).parent(".field_wrap").removeClass("error email-error");
      } else {
        $(this).parent(".field_wrap").addClass("error email-error");
        email_check = false;
      }
    });
  return email_check;
}

// Phone Field Validation
function phoneValidation() {
  let phoneCheck = true;
  intRegex = /[0-9 -()+]+$/;
  $("#ContactForm_1")
    .find(".phone")
    .each(function () {
      let phone = $(this).val();
      if (phone.length < 10 || phone.length > 10 || !intRegex.test(phone)) {
        $(this).parent(".field_wrap").addClass("error phone-error");
        phoneCheck = false;
      } else {
        $(this).parent(".field_wrap").removeClass("error phone-error");
      }
    });
  return phoneCheck;
}


async function checkOpenQueryAfterOTP(mobileNumber) {
  try {
    const response = await fetch(
      "https://orientform.marmeto.com/api/complaint-tracking",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${sessionStorage.getItem("complaintVerificationToken")}`
        },
        body: JSON.stringify({
          customerMobileNumber: mobileNumber,
        }),
      }
    );

    const data = await response.json();
    let hasOpenQuery = false;

    if (data.callList && Array.isArray(data.callList)) {
      data.callList.forEach((call) => {
        if (call.callStatusDescription.includes("Open")) {
          hasOpenQuery = true;
        }
      });
    }

    if (hasOpenQuery) {
      // ❌ If open complaint exists
      $(".complaint-invalid-OTP")
        .text("You already have an open complaint. Please try later.")
        .show();

      // Keep OTP popup open OR close based on UX
    } else {
      // ✅ No open complaint → proceed
      $(".complaint-invalid-OTP").hide();

      $(".complaint-otp-login-popup .cf-icon-close svg").click();
      $("#complaint-otp-verification").hide();

      $(".popup-overlay").removeClass("hidden");
      openOverlay();
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Something went wrong. Please try again.");
  }
}